import { Box, BoxStyleProps, Text } from '@frontend/ui-library';
import cx from 'classnames';

import styles from './WarningMessage.module.css';

interface WarningMessageProps extends BoxStyleProps {
  className?: string;
  children?: React.ReactNode;
}

export default function WarningMessage({
  className,
  children,
  ...boxStyleProps
}: WarningMessageProps) {
  return (
    <Box
      data-test-id="warning-message"
      className={cx(styles['base'], className)}
      {...boxStyleProps}
    >
      <Text
        as="div"
        align="center"
        size="tiny"
        weight="400"
        color="vitaminC-600"
      >
        {children}
      </Text>
    </Box>
  );
}
